import { Div } from "@tblabs/truffle";
import { TimeUtils } from "../../../Utils/TimeUtils";
import { PersonalReturnStepData } from "../Models/PersonalReturnStepData";
import { Order } from "../../../Models/Order";


export class PersonalReturnInfo extends Div
{
    constructor(data: PersonalReturnStepData)
    {
        super();
        this.MarginTopBottom(8);

        this.Append(
            new Div("meeting-info-entry").Text(`🕓 ${TimeUtils.FormattedDayHour(data.PlannedMeetingTime)}`),
            new Div("meeting-info-entry").Text(`🗺️ ${data.MeetingPlace.value || "Miejsce jeszcze nie ustalone"}`),
            data.AssignedAgentId.value &&
            new Div("meeting-info-entry").Text(`👤 Agent: ${data.AssignedAgentId.value || "jeszcze nie przypisany"}`),
            data.CashToReturn.value > 0 &&
            new Div("meeting-info-entry").Text(`💰 ${data.CashToReturn.value} zł do zwrotu`),
            data.ExtraCashToPay.value > 0 &&
            new Div("meeting-info-entry").Text(`💰 ${data.ExtraCashToPay.value} zł do dopłaty`).Bold(),
        );
    }
}

export class AdminPersonalReturnInfo extends Div
{
    constructor(order: Order, data: PersonalReturnStepData)
    {
        super();
        this.MarginTopBottom(8);

        this.Append(
            new Div("meeting-info-entry").Text(`🕓 ${TimeUtils.FormattedDayHour(data.PlannedMeetingTime)}`),
            new Div("meeting-info-entry").Text(`🗺️ ${data.MeetingPlace.value || "Miejsce jeszcze nie ustalone"}`),
            new Div("meeting-info-entry").Text(`🐤 ${order.People.Map(x => `${x.Name.value}, ${x.Phone.value}`).join("; ") || "⚠️ Brak danych klienta"}`),
            new Div("meeting-info-entry").Text(`👤 Agent: ${data.AssignedAgentId.value || "jeszcze nie przypisany"}`),
            data.CashToReturn.value > 0 &&
            new Div("meeting-info-entry").Text(`💰 ${data.CashToReturn.value} zł do zwrotu`),
            data.ExtraCashToPay.value > 0 &&
            new Div("meeting-info-entry").Text(`💰 ${data.ExtraCashToPay.value} zł do dopłaty`).Bold(),
        );
    }
}
